module.exports = __webpack_public_path__ + "img/bonon.8dce78d2.jpg";